import { render } from "./RoomUserList.vue?vue&type=template&id=38c4fea3&scoped=true"
import script from "./RoomUserList.vue?vue&type=script&lang=js"
export * from "./RoomUserList.vue?vue&type=script&lang=js"

import "./RoomUserList.vue?vue&type=style&index=0&id=38c4fea3&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c4fea3"]])

export default __exports__